interface User {
  progress?: {
    completion_percentage?: string;
    steps?: Array<{ slug: string; completed: boolean }>;
  };
}

export const getProfileCompletion = (user: User | null) => {
  const completionPercentage = user?.progress?.completion_percentage || '0%';
  const actualProgress = Number.parseInt(completionPercentage.replace('%', ''));
  const isProfileComplete = actualProgress >= 75;
  const isCloneComplete = actualProgress >= 100;
  const isZeroProgress = completionPercentage === '0%';
  const progressSteps = user?.progress?.steps || [];

  return {
    completionPercentage,
    actualProgress,
    isProfileComplete,
    isCloneComplete,
    isZeroProgress,
    progressSteps,
  };
};

/** Backend roles can carry a LinkedIn-style headline ("Engineer at X| ex-Y | ex-Z"); labels show only the role. */
export const getRoleLabel = (role?: string | null): string =>
  (role ?? '').split('|')[0].trim();
